import React, { useState, useRef } from 'react';
import buildHiddenInputs from '../../../helpers/hidden_input_builder';
import FacebookLogin from '../../../services/facebookLogin/reactComponent';

const hiddenInputsMap = (csrf_token) => ({
  emailnewsletters: 'Y',
  emailnotify: 'Y',
  emailtipsandpromotions: 'Y',
  emailspeedflatmating: 'N',
  emailfrom3rdparties: 'N',
  csrf_token,
});


const termsPath = (siteId) => siteId != 21 ? '/content/padded/terms-' : '/content/default/terms-';
const termsUrl = (country, siteId) => `${termsPath}${country == 'GB' ? 'uk' : (siteId != 21 ? 'us' : 'appartager')}`;
const privacyPath = (siteId) => siteId != 21 ? '/content/padded/privacy-' : '/content/default/privacy-';
const privacyUrl = (country, siteId) => `${privacyPath}${country == 'GB' ? 'uk' : (siteId != 21 ? 'us' : 'appartager')}`;

function Register({
  affiliateId,
  contactMode,
  country,
  csrf_token,
  facebookLoginActive,
  facebookAppLocale,
  fields,
  locationId,
  loginFromUrl,
  subDir,
  updateFields,
  userLanguage,
  userType,
  passwordInputRef,
  togglePasswordVisibility,
  passwordVisible,
  localisations,
  siteId
}) {
  const emailAgainInput = useRef();
  function validateEmailsMatch() {
    if (fields.email.value !== fields.email_again.value) {
      emailAgainInput.current.setCustomValidity(localisations.emails_must_match);
    }
  }

  function validatePasswordFields() {
    if (fields.password.value.length === 0) {
      return passwordInputRef.current.setCustomValidity(
        localisations.pass_req
      );
    }
    if (fields.password.value.length < 6) {
      return passwordInputRef.current.setCustomValidity(
        `${localisations.pass_min_char} ${fields.password.value.length}`,
      );
    }
    return true;
  }

  function clearError(event) {
    return event.target.setCustomValidity('');
  }

  function handleChange({ field_name, event }) {
    clearError(event);
    updateFields({ field_name, value: event.target.value, valid: true });
  }

  function handleRadioClick({ event }) {
    event.target.setCustomValidity('');
    updateFields({
      field_name: 'gender',
      value: event.target.value,
      valid: true,
    });
  }
  return (
    <fieldset className="authentication__form">
      {facebookLoginActive ? (
        <>
          <div className="authentication__facebook">
            <FacebookLogin
              wide={true}
              text={localisations.register_with_facebook}
              language={facebookAppLocale}
              subDirectory={subDir}
              params={{
                loginfrom_url: loginFromUrl,
                custom_password_required: 0,
                location: locationId,
                usertype_new: userType,
                referred_by: affiliateId,
              }}
            />
          </div>
          <div className="authentication__provider-divider">{localisations.or}</div>
        </>
      ) : null}
      <div className="form-group">
        <label className="form-group__title" htmlFor="first_name">
        {localisations.first_name}*
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="first_name"
          name="first_name"
          type="text"
          autoComplete={'given-name'}
          required={true}
          onInvalid={(event) =>
            event.target.setCustomValidity(localisations.first_name_req)
          }
          onChange={(event) =>
            handleChange({ field_name: 'first_name', event })
          }
          onBlur={(event) => clearError(event)}
          defaultValue={fields.first_name.value}
        />
      </div>
      <div className="form-group">
        <label className="form-group__title" htmlFor="last_name">
        {localisations.last_name}*
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="last_name"
          name="last_name"
          type="text"
          autoComplete={'family-name'}
          required={true}
          onInvalid={(event) =>
            event.target.setCustomValidity(localisations.last_name_req)
          }
          onChange={(event) => handleChange({ field_name: 'last_name', event })}
          onBlur={(event) => clearError(event)}
          defaultValue={fields.last_name.value}
        />
      </div>

      <div className="form-group">
        <label className="form-group__title" htmlFor="email">
        {localisations.email}*
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="email"
          name="email"
          type="email"
          autoComplete={'email'}
          required={true}
          onInvalid={(event) =>
            event.target.setCustomValidity(localisations.email_req)
          }
          onChange={(event) => handleChange({ field_name: 'email', event })}
          onBlur={(event) => clearError(event)}
          defaultValue={fields.email.value}
        />
      </div>
      <div className="form-group">
        <label className="form-group__title" htmlFor="email_again">
        {localisations.confirm_email}*
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="email_again"
          name="email_again"
          type="email"
          autoComplete={'email'}
          required={true}
          ref={emailAgainInput}
          onInvalid={(event) =>
            event.target.setCustomValidity(localisations.emails_must_match)
          }
          onChange={(event) => {
            handleChange({ field_name: 'email_again', event });
          }}
          onBlur={(event) => clearError(event)}
          defaultValue={fields.email_again.value}
        />
      </div>
      <div className="form-group">
        <label className="form-group__title" htmlFor="password">
        {localisations.password}*
        </label>
        <div className="form-group__password-input-wrapper">
          <input
            className="form-group__input form-group__input--wide"
            id="password"
            name="password"
            type={passwordVisible ? 'text' : 'password'}
            ref={passwordInputRef}
            autoComplete={'new-password'}
            required={true}
            minLength="6"
            onChange={(event) =>
              handleChange({ field_name: 'password', event })
            }
            onBlur={(event) => clearError(event)}
            defaultValue={fields.password.value}
          />
          <button
            className="button button--action"
            type="button"
            aria-label="Toggle password visibility"
            onClick={togglePasswordVisibility}
          >
            <span className="button__content">
              <i className="far fa-eye" aria-hidden></i>
            </span>
          </button>
        </div>
        <input
          type="hidden"
          name="password_again"
          defaultValue={fields.password.value}
        />
      </div>
      <fieldset className="authentication__gender-radios">
        <legend className="form-group__title">{localisations.gender}*</legend>
        <div className="form-group__radio">
          <input
            className="form-group__radio"
            type="radio"
            id="F"
            name="gender"
            value="F"
            defaultChecked={fields.gender.value === 'F'}
            required={true}
            onInvalid={(event) =>
              event.target.setCustomValidity(localisations.gender_req)
            }
            onClick={(event) => handleRadioClick({ event })}
          />
          <label htmlFor="F">{localisations.female}</label>
        </div>
        <div className="form-group__radio">
          <input
            className="form-group__radio"
            type="radio"
            id="M"
            name="gender"
            value="M"
            defaultChecked={fields.gender.value === 'M'}
            onClick={(event) => handleRadioClick({ event })}
          />
          <label htmlFor="M">{localisations.male}</label>
        </div>
      </fieldset>
      {buildHiddenInputs(hiddenInputsMap(csrf_token))}
      <input type="hidden" name="iso_language" value={userLanguage} />
      <div className="form-group">
        <label className="form-group__title" htmlFor="where_heard">
          {localisations.hear_about_us}
        </label>
        <input
          className="form-group__input form-group__input--wide"
          id="where_heard"
          name="where_heard"
          type="text"
          onChange={(event) => {
            handleChange({ field_name: 'where_heard', event });
          }}
          defaultValue={fields.where_heard.value}
        />
      </div>
      <div className="contact-form__submit">
        <button
          className="button button--wide"
          // need it on submit for tests - annoying
          onSubmit={() => {
            validatePasswordFields();
            validateEmailsMatch();
          }}
          onClick={() => {
            validatePasswordFields();
            validateEmailsMatch();
          }}
        >
          {contactMode == 'bytel'
            ? localisations.reg_and_get_phone_number
            : localisations.reg_and_send_message}
        </button>
      </div>
      <div className="contact-form__agreement">
        <input type="hidden" name="inagreement" value="Y" />
        { siteId == 21 ? (
          <>
            * Nous vous enverrons des e-mails dans le cadre des services que nous vous fournissons.
            Vous pouvez modifier la fréquence de ces e-mails ou vous désabonner à tout moment via Mon
            compte ou le lien figurant dans les e-mails. En cliquant sur S&apos;inscrire, vous acceptez 
            <a href={termsUrl(country, siteId)}>les conditions</a> et <a href={privacyUrl(country, siteId)}>la politique de confidentialité</a> de Appartager.
          </>         
        ) : (
          <>
            We will send you emails as part of the services we provide to you. You
            can change the frequency of these emails or unsubscribe at any time
            through My Account or the link in the emails. By clicking Register you
            agree to SpareRoom&apos;s <a href={termsUrl(country, siteId)}>terms</a> and{' '}
            <a href={privacyUrl(country, siteId)}>privacy policy</a>.
          </>
        )}
      </div>
    </fieldset>
  );
}

export default Register;
